module.exports = __webpack_public_path__ + "assets/milk-bottle-3.bc5d65b8.svg";